import { LeadTypes } from './enums';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
export type FormikSubmitForm = (() => Promise<void>) & (() => Promise<any>);

type NewsletterLeadType = `${string}_newsletter_lead_type`;
export type BlueconicLeadType = `${string}_blueconic`;

export type LeadType = LeadTypes | BlueconicLeadType | NewsletterLeadType | string;

export const getFileTypeFromUrl = (url: string) => {
  const filename = new URL(url).pathname.split('/').pop();
  const ext = filename.split('.').pop();
  switch (ext?.toLowerCase()) {
    case 'mp4':
      return 'video';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'svg':
    case 'webp':
      return 'image';
    default:
      return null;
  }
};
